/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
    logout,
    onCaptchaAdminProceed
} from "../../registration_login/actions/sessionActions";
import "../../styles/home.css";
import {
    getGuidelineLinks,
    checkModuleEnableDisable,
    loginAction,
    generateCaptcha,
    getDigilockerAccessToken,
    getDigilockerAccessToken2,
    getHelplineDetails,
    getDepartments,
    getAdminMobileOTP,
    getAdminEmailOTP,
    adminLogin,
    verifyAdminMobileOTP,
    verifyAdminEmailOTP,
} from "../actions/commonActions";
import "../../styles/candidate_nav.css";
import { useNavigate } from "react-router-dom";
import "../../styles/profile.css";
import "../../styles/registration.css";
import "../../styles/admin.css"
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import commonLabels from "../labels/common_en.json";

const AdminLogin = (props) => {
    const location = useLocation();
    // Parse query parameters from the URL
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const navigate = useNavigate();
    let accessToken = useSelector((state) => state.loginReducer.accessToken);
    let digiuserEmail = sessionStorage.getItem("userEmail") || '';
    let digiuserHscYear = sessionStorage.getItem("userHscYear") || '';
    let digiuserHscBoard = sessionStorage.getItem("userHscBoard") || '';
    let digiuserHscRollNo = sessionStorage.getItem("userHscRollNo") || '';
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let sessionToken = session && session.jwtResponse.token;
    let profileId = sessionStorage.getItem("profileId") || '';
    const { adminOTPVerfiedFlag, captchaId, adminDepartments, guidelineLinks, getHelpLineList } = useSelector((state) => state.common);
    const dispatch = useDispatch();
    const { register, handleSubmit, formState, errors, watch } = useForm({
        mode: "onChange",
    });
    const [data, setData] = useState({});
    let [forceFulLogout, setForceFulLogout] = useState(false);
    let [forceFulLogoutErrorMessage, setForceFulLogoutErrorMessage] =
        useState(false);
    let [usernameForLogin, setUsernameForLogin] = useState(false);
    let [showCaptcha, setShowCaptcha] = useState(false);
    let [enteredCaptcha, setEnteredCaptcha] = useState();
    let [userDetail, setUserDetail] = useState();
    let [loginType, setLoginType] = useState('email')
    let [otpId, setOtpId] = useState('')
    const currentDomain = window.location.hostname;
    const captchaImageUrl = `/oas/api/v1/otps/${captchaId}`;

    // useEffect(() => {
    //     if ((code != null && digiuserEmail != null && digiuserHscYear != null && digiuserHscBoard != null && digiuserHscRollNo != null) && (code != "" && digiuserEmail != "" && digiuserHscYear != "" && digiuserHscBoard != "" && digiuserHscRollNo != "")) {
    //         dispatch(getDigilockerAccessToken(code, digiuserEmail, digiuserHscYear, digiuserHscBoard, digiuserHscRollNo));
    //     }
    // }, [code, digiuserEmail, digiuserHscYear, digiuserHscBoard, digiuserHscRollNo]);

    // useEffect(() => {
    //     if ((code != null && (accessToken != null || sessionToken != null)) && (code != "" && (accessToken != "" || sessionToken != ""))) {
    //         dispatch(getDigilockerAccessToken2(code, navigate));
    //     }
    // }, [code, accessToken, sessionToken]);

    useEffect(() => {
        // dispatch(getGuidelineLinks());
        // dispatch(getHelplineDetails())
        dispatch(getDepartments());
    }, []);

    // if (accessToken || (session && session.jwtResponse.token)) {
    //     navigate("/candidate/main");
    //     // return (
    //     //   <div>
    //     //     <h6 className="d-flex justify-content-center bold-text">
    //     //       {commonLabels.HOME.YOU_ARE_LOGGED_IN}&nbsp;
    //     //       <Link
    //     //         onClick={() => {
    //     //           dispatch(logout(props, true, navigate));
    //     //         }}
    //     //       >
    //     //         {commonLabels.BUTTONS.LOGOUT}
    //     //       </Link>
    //     //       &nbsp;{commonLabels.HOME.TO_VIEW_PAGE_NOTE}&nbsp;
    //     //       <Link to="/candidate/main">{commonLabels.HOME.APPLICATION}</Link>.
    //     //     </h6>
    //     //   </div>
    //     // );
    // }

    // const handleKeyDown = (event) => {
    //     if (event.key === "Enter") {
    //         onProceed();
    //     }
    // };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // const handleKeyDownLogin = (event) => {
    //     if (event.key === "Enter") {
    //         dispatch(adminLogin(data, navigate))
    //         // dispatch(
    //         //     loginAction(
    //         //         data,
    //         //         // emailOTPResponse,
    //         //         setShowCaptcha,
    //         //         setForceFulLogout,
    //         //         setForceFulLogoutErrorMessage,
    //         //         setUsernameForLogin
    //         //     )
    //         // );
    //     }
    // };

    const handleSubmits = (event) => {
        event.preventDefault();
        dispatch(adminLogin(data, navigate))
        // dispatch(
        //     loginAction(
        //         data,
        //         // emailOTPResponse,
        //         setShowCaptcha,
        //         setForceFulLogout,
        //         setForceFulLogoutErrorMessage,
        //         setUsernameForLogin
        //     )
        // );
        // setUserDetail(data);
    };

    // const onProceed = () => {
    //     dispatch(onCaptchaAdminProceed(enteredCaptcha, captchaId, data, navigate));
    // };

    const verifyOTP = (e) => {
        e.preventDefault()
        if (loginType === 'mobile') {
            dispatch(verifyAdminMobileOTP(data, otpId))
        } else if (loginType === 'email') {
            dispatch(verifyAdminEmailOTP(data, otpId))
        }
    }

    const handleGetOTP = (e) => {
        e.preventDefault()
        if (loginType === 'mobile') {
            dispatch(getAdminMobileOTP(data, setOtpId))
        } else if (loginType === 'email') {
            dispatch(getAdminEmailOTP(data, setOtpId))
        }
    }

    return (
        <div className="row margin5">
            <div className="col-sm-12 col-md-6 position-relative1">
                <img src="/icons/home.png" className="img-responsive"></img>
                <div className="overlay-text">
                    <span>{commonLabels.HOME.WELCOME_MES_NOTE_1}</span>
                    <br />
                    <span className="font-weight-500">
                        {commonLabels.HOME.WELCOME_MES_ADMIN_NOTE}
                    </span>
                </div>
            </div>
            <div className="col-sm-12 col-md-4 mx-auto ">
                <div className="text-center p-4">
                    <p className="fs-4 fw-bold m-0">Admin Login</p>
                </div>
                <div className="d-flex gap-5 justify-content-center">
                    <div className="d-flex gap-2 " >
                        <input className="form-check-input" type="radio"  onClick={() => setLoginType('email')} name="flexRadioDefault" id="flexRadioDefault2" defaultChecked={loginType === 'email'} />
                        <label className="form-check-label" htmlFor="flexRadioDefault2">
                            Email
                        </label>
                    </div>
                    <div className="d-flex gap-2" >
                        <input className="form-check-input" type="radio" onClick={() => setLoginType('mobile')} name="flexRadioDefault" id="flexRadioDefault1" defaultChecked={loginType === 'mobile'} />
                        <label className="form-check-label" htmlFor="flexRadioDefault1">
                            Mobile
                        </label>
                    </div>
                </div>
                <form onSubmit={handleSubmits} className="loginFormSec">
                    <div className="d-flex flex-column gap-2 p-2">
                        <div className="form-group col-md-12 d-flex flex-column gap-2">
                            <label className="f11 fw-medium">
                                {loginType === 'mobile' && commonLabels.SIGN_IN.REGISTERED_MOBILE}
                                {loginType === 'email' && commonLabels.SIGN_IN.REGISTERED_EMAIL}
                                <span className="errorText">*</span>
                            </label>
                            <div className="d-flex align-items-center  position-relative">
                                <span className="position-absolute input-group-text">
                                    <i className="far fa-user"></i>
                                </span>
                                {loginType === 'email' && 
                                <input
                                    type="text"
                                    placeholder={commonLabels.SIGN_IN.REGISTERED_EMAIL_PLACEHOLDER}
                                    className="text-input bg-color"
                                    id="userName"
                                    name="userName"
                                    ref={register({
                                        required: true,
                                        validate: {
                                            email: (value) =>
                                              
                                                    /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/.test(
                                                        value)
                                        },
                                    })}
                                    onChange={handleInputChange}
                                />}
                                {loginType === 'mobile' && 
                                <input
                                    type="text"
                                    placeholder={commonLabels.SIGN_IN.REGISTERED_MOBILE_PLACEHOLDER}
                                    className="text-input bg-color"
                                    id="userName"
                                    name="userName"
                                    ref={register({
                                        required: true,
                                        validate: {
                                            email: (value) =>
                                                
                                                    /^\s*([1-9]{1}[0-9]{9})\s*$/.test(value)
                                                   
                                        },
                                    })}
                                    onChange={handleInputChange}
                                />}
                            </div>
                            {_.get("userName.type", errors) === "required" && (
                                <p className="errorText f11">
                                    {commonLabels.VALIDATE_MESSAGE.USERNAME_REQ}
                                </p>
                            )}
                            {errors.userName?.type === "email" && (
                                <p className="errorText f11">
                                    {commonLabels.SIGN_IN.VALID_VALUE_NOTE}{" "}
                                </p>
                            )}
                        </div>
                        <div className="form-group col-md-12 d-flex flex-column gap-1">
                            <label className="f11 fw-medium">
                                {commonLabels.SIGN_IN.PASSWORD}
                                <span className="errorText">*</span>
                            </label>
                            <div className="d-flex align-items-center  position-relative">
                                <span className="position-absolute input-group-text">
                                    <i className="fas fa-lock"></i>
                                </span>
                                <input
                                    type="password"
                                    className="text-input bg-color"
                                    id="password"
                                    name="Password"
                                    placeholder={commonLabels.SIGN_IN.ENTER_PASSWORD}
                                    ref={register({ required: true })}
                                    // disabled={
                                    //     errors.userName?.type === "email" ||
                                    //     _.get("userName.type", errors) ||
                                    //     !watch("userName")
                                    // }
                                    onChange={handleInputChange}
                                />
                            </div>
                            {_.get("Password.type", errors) === "required" && (
                                <p className="errorText">
                                    {commonLabels.VALIDATE_MESSAGE.PASSWORD_REQ}
                                </p>
                            )}
                        </div>

                        <div className="form-group col-md-12 d-flex flex-column gap-1">
                            <label className="f11 fw-medium">
                                Department
                                <span className="errorText">*</span>
                            </label>
                            <div className="d-flex gap-2 align-items-center  position-relative">
                                <select
                                    className="select"
                                    name="departmentId"
                                    onChange={handleInputChange}
                                    ref={register({ required: true })}
                                >
                                    <option value="">Select a department</option>
                                    { Array.isArray(adminDepartments) && adminDepartments?.map((department, i) => (
                                        <option key={i} value={department.id}>
                                            {department.name}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    type="button"
                                    className=" btn btn-primary custom_button  button_custom col-md-3"
                                    onClick={handleGetOTP}
                                    disabled={!watch('departmentId')}
                                >
                                    {loginType === 'mobile' ? 'Get Mobile OTP' : 'Get Email OTP'}
                                </button>
                            </div>

                            {_.get("departmentId.type", errors) === "required" && (
                                <p className="errorText">
                                    {commonLabels.VALIDATE_MESSAGE.DEPARTMENT_REQ}
                                </p>
                            )}
                        </div>

                        {/* <div className="form-group col-md-12 d-flex flex-column gap-1">
                            <label className="f11 fw-medium">
                                Department
                                <span className="errorText">*</span>
                            </label>
                            <div className="d-flex gap-2 align-items-center">
                                <select
                                    className="select"
                                    name="departmentId"
                                    onChange={handleInputChange}
                                    ref={register({ required: true })}
                                >
                                    <option value="">Select a department</option>
                                    {adminDepartments?.map((department, i) => {
                                        return (
                                            <option key={i} value={department.id}>{department.name}</option>
                                        )
                                    })}
                                </select>
                                <button type="button" className=" btn btn-primary custom_button  button_custom col-md-3" onClick={handleGetOTP}>
                                    {loginType === 'mobile' ? 'Get Mobile OTP' : 'Get Email OTP'}
                                </button>

                            </div>
                            {_.get("departmentId.type", errors) === "required" && (
                                <p className="errorText">
                                    {commonLabels.VALIDATE_MESSAGE.DEPARTMENT_REQ}
                                </p>
                            )}
                        </div> */}
                        {
                            loginType === 'mobile'
                            &&
                            <div className="form-group col-md-12 d-flex flex-column gap-1">
                                <label className="f11 fw-medium">
                                    {commonLabels.COMMON.MOBILE_OTP}
                                    <span className="errorText">*</span>
                                </label>
                                
                                <div className="d-flex align-items-center gap-2  position-relative">
                                    <span className="position-absolute input-group-text">
                                        <i className="fas fa-lock"></i>
                                    </span>
                                    <input
                                        type="number"
                                        className="text-input bg-color"
                                        id="mobileOTP"
                                        name="mobileOTP"
                                        placeholder={"Enter Mobile OTP"}
                                        ref={register({ required: true })}
                                        // disabled={
                                        //     errors.userName?.type === "email" ||
                                        //     _.get("userName.type", errors) ||
                                        //     !watch("userName")
                                        // }
                                        onChange={handleInputChange}
                                    />
                                    <button type="button" disabled={!(data && data.mobileOTP)} className=" btn btn-primary custom_button  button_custom col-md-3" onClick={verifyOTP}>
                                        Verify OTP
                                    </button>
                                </div>
                                {/* {_.get("mobileOTP.type", errors) === "required" && (
                                            <p className="errorText">
                                                {commonLabels.VALIDATE_MESSAGE.PASSWORD_REQ}
                                            </p>
                                        )} */}
                            </div>
                        }
                        {
                            loginType === 'email'
                            &&
                            <div className="form-group col-md-12 d-flex flex-column gap-1">
                                <label className="f11 fw-medium">
                                    {commonLabels.COMMON.EMAIL_OTP}
                                    <span className="errorText">*</span>
                                </label>
                                <div className="d-flex align-items-center gap-2  position-relative">
                                    <span className="position-absolute input-group-text">
                                        <i className="fas fa-lock"></i>
                                    </span>
                                    <input
                                        type="number"
                                        // className="form-control f10 no-border borderRadius10 box-shadow-none"
                                        className="text-input bg-color"
                                        id="emailOTP"
                                        name="emailOTP"
                                        placeholder={"Enter Email OTP"}
                                        ref={register({ required: true })}
                                        // disabled={
                                        //     errors.userName?.type === "email" ||
                                        //     _.get("userName.type", errors) ||
                                        //     !watch("userName")
                                        // }
                                        onChange={handleInputChange}
                                    />
                                    <button type="button"  disabled={!(data && data.emailOTP)}  className=" btn btn-primary custom_button  button_custom col-md-3" onClick={verifyOTP}>
                                        Verify OTP
                                    </button>
                                </div>
                                {/* {_.get("emailOTP.type", errors) === "required" && (
                                            <p className="errorText">
                                                {commonLabels.VALIDATE_MESSAGE.PASSWORD_REQ}
                                            </p>
                                        )} */}
                            </div>
                        }
                        
                        <div className="form-group col-md-12">
                            <div className="input-group">
                                <button
                                    type="submit"
                                    disabled={!(formState.isValid && adminOTPVerfiedFlag)}
                                    className=" btn btn-primary custom_button  button_custom w-100"
                                >
                                    {commonLabels.SIGN_IN.LOGIN}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;

